import { useState, useRef } from "react";
import { Modal } from "@mui/material";
import { Close } from "@mui/icons-material";
import styles from "./UploadLDC.module.css";
import { toast } from "react-toastify";
import {
  generateSchedule,
  uploadLDC,
} from "../../../../Services/BuySell/Listing";
import { ReactComponent as ViewIcon } from "../../../../assets/images/view.svg";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchActiveConnection,
  fetchMainScreenActiveConnection,
} from "../../../../Redux/Slices/CapacitySlice";
import { useLocation } from "react-router-dom";
import { handleCreateSchedule } from "../../../../Services/Schedule/schedule";
import { useDroppable } from "@dnd-kit/react";
import { DndContext } from "@dnd-kit/core";
import PreviewModal from "../../../../commons/PreviewModal/PreviewModal";

const UploadLDC = ({ open, onClose, connectionId, mode, capacityId }) => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);
  const [previewFileUrl, setPreviewFileUrl] = useState(null);
  const dispatch = useDispatch();
  const location = useLocation();
  const id = useSelector((state) => state.CapacitySlice?.activeMain?.id);
  let capId = capacityId || location?.search?.split("=")[1] || id;
  const inputRef = useRef();

  console.log("connectionId heree", connectionId);

  // DnD Kit droppable setup
  const { setNodeRef, isOver } = useDroppable({
    id: "ldc-dropzone",
  });

  const handleFileChange = (e) => {
    if (e.target.files[0].type !== "application/pdf") {
      toast.error("Only PDF files are allowed!");
      return;
    }
    setSelectedFile(e.target.files[0]);
  };

  const handleDrop = (event) => {
    event.preventDefault();
    const file = event.dataTransfer.files[0];
    if (file) setSelectedFile(file);
  };

  const handleClick = () => {
    inputRef.current.click();
  };

  async function handleSubmit() {
    try {
      setLoading(true);
      const formData = new FormData();
      formData.append("file", selectedFile);
      const res = await uploadLDC(formData, connectionId);

      if (res?.data?.code === 200) {
        toast.success("LDC uploaded successfully!");
        const aa = await handleCreateSchedule(connectionId);
        if (aa?.data?.code === 200) {
          toast.success("Schedule generated successfully!");
        }
      }
      dispatch(fetchActiveConnection({ curr: 0, capId: capId }));
      dispatch(fetchMainScreenActiveConnection({ capId: capId }));
      onClose();
    } catch (error) {
      toast.error("Failed to upload LDC.");
    } finally {
      setLoading(false);
    }
  }

  const handleViewDoc = async (id) => {
    try {
      if (selectedFile) {
        setPreviewFileUrl(URL.createObjectURL(selectedFile));
        setPreviewModal(true);
      } else {
        toast.error("Document URL not found");
      }
    } catch (err) {
      toast.error("Could not fetch document URL.");
    }
  };

  const handleClosePreview = () => {
    setPreviewModal(false);
    setPreviewFileUrl(null);
  };

  return (
    <Modal open={open} onClose={onClose}>
      <div className={styles.modal}>
        <div className={styles.header}>
          <span className={styles.title}>LDC Approval</span>
          <button className={styles.close} onClick={onClose}>
            <Close fontSize="medium" />
          </button>
        </div>
        <div style={{ background: "#f1f1f1ff", padding: "20px" }}>
          <DndContext>
            <div
              ref={setNodeRef}
              className={`${styles.tableWrapper} ${
                isOver ? styles.dragOver : ""
              }`}
              onClick={handleClick}
              onDrop={handleDrop}
              onDragOver={(e) => e.preventDefault()}
              style={{
                border: "1px solid #e0e0e0",
                borderRadius: "12px",
                background: "#fafbfc",
                padding: "32px",
                textAlign: "center",
                cursor: "pointer",
              }}
            >
              <input
                accept=".pdf,.doc,.docx"
                type="file"
                onChange={handleFileChange}
                ref={inputRef}
                style={{ display: "none" }}
              />
              <div
                style={{
                  fontSize: "32px",
                  color: "#bdbdbd",
                  marginBottom: "8px",
                }}
              >
                +
              </div>
              <div style={{ fontSize: "16px", color: "#666" }}>
                Drag and drop, or click to{" "}
                <span style={{ color: "#ff8800" }}>Upload</span>
                <br />
                LDC Document
              </div>
              {selectedFile && (
                <div
                  className={styles.fileName}
                  style={{
                    marginTop: "16px",
                    color: "#333",
                  }}
                >
                  Selected file: {selectedFile.name}
                  <div
                    type="button"
                    onClick={(e) => {
                      e.stopPropagation();
                      handleViewDoc();
                    }}
                    aria-label={`View document }`}
                  >
                    <ViewIcon />
                  </div>
                </div>
              )}
            </div>
          </DndContext>
        </div>
        {mode !== "view" && (
          <div className={styles.footer}>
            <button onClick={onClose} className={styles.reject}>
              Cancel
            </button>
            <button
              className={styles.approve}
              onClick={handleSubmit}
              disabled={!selectedFile || loading}
              style={{
                cursor: !selectedFile ? "not-allowed" : "pointer",
                opacity: !selectedFile ? 0.6 : 1,
                pointerEvents: !selectedFile ? "none" : "auto",
              }}
            >
              {loading ? "Generating..." : "Generate Schedule"}
            </button>
          </div>
        )}
        <PreviewModal
          open={previewModal}
          onClose={handleClosePreview}
          fileUrl={previewFileUrl}
        />
      </div>
    </Modal>
  );
};

export default UploadLDC;
